import { FileUpload } from 'client/components/core/Sidebar/components/Settings/components'
import { SettingsProps } from 'client/components/core/Sidebar/components/Settings/entities'
import {
  useUpdateEntity,
  useUpdateProp,
} from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { mimeTypes } from 'client/constants/editorSettings'
import { DataFile } from 'client/store/files/filesReducer'
import { ButtonActionTypeEnum } from 'common/enums/ButtonActionTypeEnum'
import React from 'react'
import { usePreserveEntityFieldsAcrossDiscriminator } from 'src/editor/hooks/use-preserve-fields-across-discriminator/use-preserve-entity-fields-across-discriminator'
import { ActionButtonEntityInterface } from 'src/shared/entities/button/action-button.schema'
import { DownloadFileActionButtonEntityInterface } from 'src/shared/entities/button/download-file.action-button.schema'
import { DownloadFileWebsiteActionButtonEntityInterface } from 'src/shared/entities/website-button/download-file-website-button.schema'
import { WebsiteButtonEntityInterface } from 'src/shared/entities/website-button/website-button.schema'
import { FileIdEntityInterface } from 'src/shared/schemas/buttons/buttons-entities-properties.schema'

type CommonActionButtonEntityInterface =
  | ActionButtonEntityInterface
  | WebsiteButtonEntityInterface

type CommonDownloadFileActionButtonEntityInterface =
  | DownloadFileActionButtonEntityInterface
  | DownloadFileWebsiteActionButtonEntityInterface

export const ButtonDownloadFileActionSettings = ({
  entity,
}: SettingsProps<CommonActionButtonEntityInterface>) => {
  const updateProp = useUpdateProp(
    entity as CommonDownloadFileActionButtonEntityInterface,
  )
  const updateEntity = useUpdateEntity<CommonActionButtonEntityInterface>()
  usePreserveEntityFieldsAcrossDiscriminator({
    entity: entity as CommonDownloadFileActionButtonEntityInterface,
    discriminator: [
      { key: 'action', value: ButtonActionTypeEnum.DownloadFile },
    ],
    preservedKeys: ['fileId'],
  })

  const removeFileId = () => {
    const updatedEntity = { ...entity }
    delete (
      updatedEntity as CommonActionButtonEntityInterface &
        Partial<FileIdEntityInterface>
    ).fileId
    updateEntity(updatedEntity)
  }
  return entity.action === ButtonActionTypeEnum.DownloadFile ? (
    <FileUpload
      fileId={entity.fileId}
      afterUpload={(file: DataFile) => updateProp('fileId')(file.id)}
      removeFile={removeFileId}
      mimeTypes={mimeTypes.all}
    />
  ) : null
}
